import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserLink from '../../../User/Link/UserLink';
import BasicUserName from '../../../User/BasicUserName';

import s from './OwnedByUser.scss';

export interface Props {
  owner: PapiUser;
  className?: string;
}

const OwnedByUser: React.FC<React.PropsWithChildren<Props>> = ({ owner, className }) => {
  const { t } = useTranslation();
  return (
    <UserLink className={classnames(s['root'], className)} user={owner}>
      {t('sidebar.blockTitle.owned_by', {
        postProcess: 'reactPostprocessor',
        owner: <BasicUserName user={owner} />,
      })}
    </UserLink>
  );
};
OwnedByUser.displayName = 'OwnedByUser';

export default OwnedByUser;
